export const environment = {
  production: false,
  urlApi: 'https://kwau3y5pa7.execute-api.us-east-1.amazonaws.com/dev/api/v1',
  // urlApi: 'http://192.168.168.128:8010/api/v1',
  urlPdfApi: 'https://z7vn0jdawj.execute-api.us-east-1.amazonaws.com/dev/api/v1',
  // API interna de CradleCode con el catálogo de códigos postales (Copomex), sin autenticación; se usa la de producción también en desarrollo
  urlCopomexApi: 'https://34noe7h394.execute-api.us-east-1.amazonaws.com/prod/api/v1',
  sentry: {
    // identificador público del proyecto en Sentry, no es un secreto
    dsn: 'https://c5dabc5377a6f5a6c297523c30780f95@o4511900227993600.ingest.us.sentry.io/4511901066330112',
    // etiqueta con la que se filtran los eventos en el dashboard de Sentry
    environment: 'development',
    // porcentaje de navegaciones a las que se les registra el detalle de rendimiento, 1.0 = 100%
    // ojo: los errores NO se muestrean, esos siempre se envían al 100%
    tracesSampleRate: 1.0,
    // porcentaje de sesiones que se graban en video aunque no ocurra ningún error, 1.0 = 100%
    replaysSessionSampleRate: 1.0,
    // porcentaje de sesiones que se guardan cuando sí ocurre un error, incluye los ~60s previos al error
    replaysOnErrorSampleRate: 1.0,
    // solo el backend local, que sí acepta cualquier header en su CORS de FastAPI;
    // NO agregar aquí las URLs de execute-api: el API Gateway responde el preflight de CORS
    // con una lista fija de headers permitidos que no incluye sentry-trace ni baggage,
    // y el navegador termina bloqueando toda petición al API
    tracePropagationTargets: [
      'localhost'
    ]
  },
  firebase: {
    projectId: "varever-certificates",
    appId: "1:722018758567:web:3efaf4612a272ff89f9082",
    storageBucket: "varever-certificates.appspot.com",
    apiKey: "AIzaSyCyTk0_-KWcz8M_OsDbKtqNBL1fCu6Dqw4",
    authDomain: "varever-certificates.firebaseapp.com",
    messagingSenderId: "722018758567",
    measurementId: "G-3ZPDZMV3M9"
  }
};
